module.exports = __webpack_public_path__ + "e74ea44fcff3abc883028328e5d27ca3.MP3";